import LegalPage from "@/pages/LegalPage";

const CookiesPage = () => (
    <LegalPage
        meta={{
            kicker: "Legal",
            title: "Cookie Policy.",
            intro:
                "Lexafide uses cookies and similar technologies on lexafide.com to keep the site working, understand how it's used, and improve your experience. This page explains what they do and how you can control them.",
            lastUpdated: "January 2026",
        }}
        sections={[
            {
                heading: "What Are Cookies",
                body:
                    "Cookies are small text files placed on your device when you visit a website. They allow the site to recognize your device, remember preferences, and collect usage information. Similar technologies include local storage, pixels, and SDK identifiers.",
            },
            {
                heading: "Categories We Use",
                list: [
                    "Strictly necessary — required for the site to function, such as session integrity and security. These cannot be disabled.",
                    "Functional — remember your preferences (e.g., consent choices, last-visited page).",
                    "Analytics — help us understand visitor behavior in aggregate (e.g., which pages perform best).",
                    "Advertising — only used with your explicit consent to measure the effectiveness of campaigns.",
                ],
            },
            {
                heading: "Examples of Cookies",
                list: [
                    "cookieyes-* — manages your consent preferences (1 year).",
                    "_cfuvid — Calendly session continuity for booking flows (session-only).",
                    "_reb2bloaded — anonymous B2B visitor identification (less than a minute).",
                ],
            },
            {
                heading: "Managing Your Preferences",
                body:
                    "You can change or withdraw your consent at any time using the \"Cookie preferences\" link in our site footer or the small consent button at the bottom-left of the page. Most browsers also let you block or delete cookies via their settings — note that disabling strictly necessary cookies may break parts of the site.",
            },
            {
                heading: "Do Not Track",
                body:
                    "Some browsers transmit \"Do Not Track\" (DNT) signals. We currently honor industry-standard cookie consent banners as our authoritative signal. We do not separately respond to DNT headers, but you can disable optional cookies directly in our consent center.",
            },
            {
                heading: "Updates",
                body:
                    "We may add, change, or remove cookies as our site evolves. Material updates will be reflected on this page along with a new \"Last updated\" date.",
            },
        ]}
    />
);

export default CookiesPage;
